import React, { PropsWithChildren, useRef } from "react";
import styles from "./styles.module.scss";
import { Focusable, FocusableProps } from "@blacknut/spatialnav-sdk/dist";
import clsx from "clsx";
import Ripple, { RippleType } from "../Ripple";

export interface ButtonProps
  extends Partial<
    Pick<
      FocusableProps,
      "onNavigationFailed" | "onFocus" | "onBlur" | "disabled"
    >
  > {
  onClick: (e: React.UIEvent<HTMLElement>) => void;
  variant?: "primary" | "secondary" | "iconButton";
  className?: string;
  id?: string;
  testID?: string;
}
const Button = (props: PropsWithChildren<ButtonProps>) => {
  const { onClick, variant = "primary", className, disabled = false } = props;
  const rippleRef = React.useRef<RippleType>(null);
  const lastPressedRef = useRef<number>();
  const myClick = React.useCallback(
    (e: React.UIEvent<HTMLElement>) => {
      if (e.timeStamp - (lastPressedRef.current || 0) > 200) {
        //avoid double click
        rippleRef.current?.ripple(e, onClick);
        lastPressedRef.current = e.timeStamp;
      }
    },
    [onClick]
  );

  return (
    <Focusable
      component="button"
      id={props.id}
      disabled={disabled}
      className={clsx([
        styles.button,
        variant === "primary" && styles.primary,
        variant === "secondary" && styles.secondary,
        variant === "iconButton" && styles.iconButton,
        className,
      ])}
      onClick={myClick}
      onPressEnter={myClick}
      onNavigationFailed={props.onNavigationFailed}
      onFocus={props.onFocus}
      data-testid={props.testID}
    >
      <Ripple
        ref={rippleRef}
        className={clsx([styles.ripple])}
        rippleStyle={{
          radius: "4.2rem",
        }}
      >
        {props.children}
      </Ripple>
    </Focusable>
  );
};
export { Button };
export default Button;
